import { useState } from 'react';
import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Iconify from '../../../components/iconify/iconify';
import ImageWithFallback from '../../../components/ImageWithFallback';


// ----------------------------------------------------------------------

export default function UserTableRow({
  selected,
  rowNumber,
  description,
  image,
  shortStatement,
  commentsCount,
  onViewComments,
  onDelete,
  onEdit,
  isArchived,
  onArchive,
  onRestore,
}) {
  const [open, setOpen] = useState(null);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleMenuAction = (action) => () => {
    handleCloseMenu();
    action();
  };

  return (
    <>
      <TableRow hover tabIndex={-1} selected={selected}>
        <TableCell sx={{ width: "5%", fontWeight: 500 }}>
          {rowNumber}
        </TableCell>
        <TableCell>
          {shortStatement}
        </TableCell>

        <TableCell dangerouslySetInnerHTML={{ __html: description }} />

        <TableCell>
          <ImageWithFallback path={image} alt="" style={{ width: 100 }} />
        </TableCell>

        <TableCell>
          <Button
            size="small"
            variant="outlined"
            onClick={onViewComments}
            startIcon={<Iconify icon="eva:message-circle-outline" />}
            sx={{ textTransform: 'none' }}
          >
            View {commentsCount > 0 ? `(${commentsCount})` : ''}
          </Button>
        </TableCell>

        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        {!isArchived && (
          <>
            <MenuItem onClick={handleMenuAction(onEdit)}>
              <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
              Edit
            </MenuItem>

            <MenuItem onClick={handleMenuAction(onArchive)}>
              <Iconify icon="eva:archive-fill" sx={{ mr: 2 }} />
              Archive
            </MenuItem>
          </>
        )}

        {isArchived && (
          <MenuItem onClick={handleMenuAction(onRestore)}>
            <Iconify icon="eva:undo-fill" sx={{ mr: 2 }} />
            Restore
          </MenuItem>
        )}

        <MenuItem onClick={handleMenuAction(onDelete)} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

UserTableRow.propTypes = {
  commentsCount: PropTypes.number,
  onViewComments: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  isArchived: PropTypes.bool,
  onArchive: PropTypes.func,
  onRestore: PropTypes.func,
  rowNumber: PropTypes.any,
  shortStatement: PropTypes.any,
  description: PropTypes.any,
  image: PropTypes.any,
  selected: PropTypes.any,
};
